module.exports = __webpack_public_path__ + "img/person-bounding-box.0633f756.svg";